exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "[data-v-e4bbf7d8] td.is-label{background:#f5f7fa;color:#303133;font-weight:600}.link-text[data-v-e4bbf7d8]{color:#409eff;text-decoration:none}.link-text[data-v-e4bbf7d8]:hover{text-decoration:underline}", "", {"version":3,"sources":["/workspace/src/views/banquet-task/pages/BanquetTaskRecordDetail.vue"],"names":[],"mappings":"AACA,8BAA8B,mBAAmB,cAAc,eAAe,CAC7E,AACD,4BAA4B,cAAc,oBAAoB,CAC7D,AACD,kCAAkC,yBAAyB,CAC1D","file":"BanquetTaskRecordDetail.vue","sourcesContent":["\n[data-v-e4bbf7d8] td.is-label{background:#f5f7fa;color:#303133;font-weight:600\n}\n.link-text[data-v-e4bbf7d8]{color:#409EFF;text-decoration:none\n}\n.link-text[data-v-e4bbf7d8]:hover{text-decoration:underline\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e4bbf7d8","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/banquet-task/pages/BanquetTaskRecordDetail.vue
// module id = 3283
// module chunks = 354